import { useInfiniteQuery } from '@tanstack/react-query';

import { IProductsParams } from '@app/models/interfaces';
import Api from '@app/services/api';

interface IProps extends IProductsParams {
  catalog_uid?: string;
}

export const useGetCatalogProductsQuery = ({ catalog_uid, limit, q, ...params }: IProps) => {
  return useInfiniteQuery({
    queryKey: ['getCatalogProducts', { q, limits_for_user_id: params.limits_for_user_id }],
    queryFn: async ({ pageParam = 0 }) => {
      return await Api.products.getCatalogProducts({ offset: pageParam, q, limit, ...params }, catalog_uid || '');
    },
    getNextPageParam: (current, allPages) => {
      const count = allPages.length * (limit || 1);
      return count >= (current.total || 0) ? undefined : count;
    },
    enabled: !!q,
  });
};
